
export const isFBBrowserUserAgent = (userAgent: string): boolean => {
  return userAgent.includes("FBAN") ||
    userAgent.includes("FB_IAB");
};

export const isIGBrowserUserAgent = (userAgent: string): boolean => {
  return userAgent.includes("Instagram");
};

export const isTikTokBrowserUserAgent = (userAgent: string): boolean => {
  return userAgent.includes("TikTok");
};

export const shouldDisableSingleSignOn = (): boolean => {
  return (typeof window !== "undefined" &&
    isFBBrowserUserAgent(window.navigator.userAgent)) ||
    isIGBrowserUserAgent(window.navigator.userAgent) ||
    isTikTokBrowserUserAgent(window.navigator.userAgent);
};